var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-img',{staticClass:"align-center position-absolute",staticStyle:{"background-image":"linear-gradient(to top left, #646464 0%, #1b1b1b 80%)"},attrs:{"height":"100%"}},[_c('v-main',[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }